export default function Drone(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3295_3373)">
                <path
                    d="M13.5781 13.5791L19.6571 19.658M34.4202 34.4212L28.3413 28.3422"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M34.4202 13.5791L28.3413 19.658M13.5781 34.4212L19.6571 28.3422"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M28.3405 19.6582H19.6562V28.3424H28.3405V19.6582Z" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M34.4227 19.6579C35.625 19.6579 36.8003 19.3014 37.8 18.6334C38.7996 17.9654 39.5788 17.0161 40.0389 15.9053C40.499 14.7945 40.6194 13.5722 40.3848 12.393C40.1503 11.2138 39.5713 10.1306 38.7211 9.28049C37.871 8.43033 36.7878 7.85136 35.6086 7.61681C34.4295 7.38225 33.2072 7.50263 32.0964 7.96274C30.9856 8.42283 30.0362 9.20199 29.3682 10.2017C28.7002 11.2013 28.3438 12.3766 28.3438 13.5789"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M34.4227 28.3418C35.625 28.3418 36.8003 28.6983 37.8 29.3663C38.7996 30.0343 39.5788 30.9836 40.0389 32.0944C40.499 33.2052 40.6194 34.4275 40.3848 35.6067C40.1503 36.7859 39.5713 37.8691 38.7211 38.7192C37.871 39.5693 36.7878 40.1483 35.6086 40.3829C34.4295 40.6174 33.2072 40.4971 32.0964 40.037C30.9856 39.5768 30.0362 38.7977 29.3682 37.798C28.7002 36.7983 28.3438 35.6231 28.3438 34.4207"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5789 28.3418C12.3766 28.3418 11.2013 28.6983 10.2017 29.3663C9.20199 30.0343 8.42283 30.9836 7.96274 32.0944C7.50263 33.2052 7.38225 34.4275 7.61681 35.6067C7.85136 36.7859 8.43033 37.8691 9.28049 38.7192C10.1306 39.5693 11.2138 40.1483 12.393 40.3829C13.5722 40.6174 14.7945 40.4971 15.9053 40.037C17.0161 39.5768 17.9654 38.7977 18.6334 37.798C19.3014 36.7983 19.6579 35.6231 19.6579 34.4207"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5789 19.6579C12.3766 19.6579 11.2013 19.3014 10.2017 18.6334C9.20199 17.9654 8.42283 17.0161 7.96274 15.9053C7.50263 14.7945 7.38225 13.5722 7.61681 12.393C7.85136 11.2138 8.43033 10.1306 9.28049 9.28049C10.1306 8.43033 11.2138 7.85136 12.393 7.61681C13.5722 7.38225 14.7945 7.50263 15.9053 7.96274C17.0161 8.42283 17.9654 9.20199 18.6334 10.2017C19.3014 11.2013 19.6579 12.3766 19.6579 13.5789"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3295_3373">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
